import { BcAntenatalRadioTextboxField } from "../BcAntenatalRadioTextboxField";

class PresentPregnancyAssistedReproductiveTechnology {
    public HasAssistedReproductiveTechnology?: boolean = null;
    public HasOvarianStimulation?: boolean;
    public HasIntrauterineInsemination?: boolean;
    public HasOvarianStimulationPlusIUI?: boolean;
    public InVitroFertilization: BcAntenatalRadioTextboxField;
    public IntracytoplasmicSpermInjection: BcAntenatalRadioTextboxField;
    public Other: BcAntenatalRadioTextboxField;

    public constructor(fields?: Partial<PresentPregnancyAssistedReproductiveTechnology>) {
        Object.assign(this, fields);
        this.InVitroFertilization = new BcAntenatalRadioTextboxField(fields?.InVitroFertilization);
        this.IntracytoplasmicSpermInjection = new BcAntenatalRadioTextboxField(fields?.IntracytoplasmicSpermInjection);
        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
    }

    public hasSelectedAnyAssistedReproductiveTechnology(): boolean {
        return this.HasOvarianStimulation
            || this.HasIntrauterineInsemination
            || this.HasOvarianStimulationPlusIUI
            || this.InVitroFertilization.hasSelected()
            || this.IntracytoplasmicSpermInjection.hasSelected()
            || this.Other.hasSelected();
    }

    public setAllchildFieldsAsFalse(): void {
        this.HasOvarianStimulation = false;
        this.HasIntrauterineInsemination = false;
        this.HasOvarianStimulationPlusIUI = false;
        this.InVitroFertilization.Value = false;
        this.IntracytoplasmicSpermInjection.Value = false;
        this.Other.Value = false;
    }
}

export { PresentPregnancyAssistedReproductiveTechnology };
